import type { Router } from "vue-router";
import type { Unhead } from "unhead/types";

interface RouteSeo {
  title: string;
  description: string;
}

const DEFAULT_SEO: RouteSeo = {
  title: "Cycle Rider — платформа для анализа велотренировок",
  description:
    "Платформа для анализа велотренировок: мощность, пульс, скорость, каденс. Загрузка FIT/GPX файлов.",
};

const SEO_MAP: Record<string, RouteSeo> = {
  "": {
    title:
      "Cycle Rider — платформа для анализа велотренировок: мощность, пульс, скорость, каденс",
    description:
      "Платформа для анализа велотренировок: мощность, пульс, скорость, каденс. Загрузите FIT/GPX файлы и получите детальную аналитику.",
  },
  explore: {
    title: "Лента тренировок — Cycle Rider",
    description: "Публичная лента велотренировок с картой и статистикой.",
  },
  routes: {
    title: "Построение маршрутов — Cycle Rider",
    description:
      "Рисуйте велосипедные маршруты на карте и выгружайте GPX для навигации.",
  },
  list_workouts: {
    title: "Мои тренировки — Cycle Rider",
    description: "Ваша коллекция велотренировок с аналитикой.",
  },
  upload_workouts: {
    title: "Загрузить тренировку — Cycle Rider",
    description:
      "Загрузите FIT или GPX файл и получите детальный анализ тренировки.",
  },
  workout_item: {
    title: "Тренировка — Cycle Rider",
    description: "Детальный анализ велотренировки: мощность, пульс, скорость.",
  },
  workout_public_item: {
    title: "Тренировка — Cycle Rider",
    description: "Публичный разбор велотренировки с картой и статистикой.",
  },
  preferences: {
    title: "Настройки — Cycle Rider",
    description: "Управление профилем и настройками приложения.",
  },
  login: {
    title: "Вход — Cycle Rider",
    description: "Войдите в аккаунт Cycle Rider.",
  },
  signup: {
    title: "Регистрация — Cycle Rider",
    description: "Создайте аккаунт и начните анализировать велотренировки.",
  },
  "recover-password": {
    title: "Восстановление пароля — Cycle Rider",
    description: "Восстановите доступ к аккаунту Cycle Rider.",
  },
  "404": {
    title: "404 — страница не найдена — Cycle Rider",
    description: "Запрошенная страница не существует или была перемещена.",
  },
};

export function setupSeo(router: Router, head: Unhead) {
  const update = () => {
    const route = router.currentRoute.value;
    const name = route.name as string | undefined;
    const key = route.path === "/" ? "" : name || "";
    const seo = SEO_MAP[key] || DEFAULT_SEO;
    head.push({
      title: seo.title,
      meta: [{ name: "description", content: seo.description }],
    });
  };

  update();
  router.afterEach(() => update());
}
